import api from "./axios/config";


export async function fetchGenerals() {
  try {
    const { data } = await api.get('generals');

    return { success: true, generalList: data.data };
  } catch (error) {
    return { success: false, error };
  }
}

export async function createGeneral(generalData) {
  try {
    const { data } = await api.post('generals', generalData);

    return { success: true, general: data };
  } catch (error) {
    return { success: false, error };
  }
}

export async function updateGeneral(generalData) {
  try {
    const { data } = await api.patch(`generals/${generalData.id}`, generalData);

    return { success: true, general: data };
  } catch (error) {
    return { success: false, error };
  }
}

export async function deleteGeneral(generalId) {
  try {
    await api.delete(`generals/${generalId}`);
    
    return { success: true };
  } catch (error) {
    return { success: false, error };
  }
} 